import React from 'react';

const LeftSliderPtc = () => {
    return (
        <>
            <div id="my-carousel" class="carousel slide carousel-fade" data-ride="carousel" data-interval="5000">
                <div class="carousel-inner">
                    <div class="carousel-item active">                        
                        <a href="http://sh.st/st/4152f4bc9d1aca5236b3ab14a650a949/multicoinads.com/?r=36276" target="_blank" rel="noreferrer">
                           <img class="d-block w-100" src="https://www.multicoinads.com/300promo.png" width="100%" alt="multicoinads.com"/>
                        </a>
                    </div>
                    <div class="carousel-item">
                        <a href="http://sh.st/st/4152f4bc9d1aca5236b3ab14a650a949/elios.ltd/partner/zaids2641" target="_blank" rel="noreferrer">
                            <img class="d-block w-100" src="./images/elios.ltd.png" width="100%" alt="elios.ltd"/>
                        </a>
                    </div>
                    <div class="carousel-item">
                        <a href="http://sh.st/st/4152f4bc9d1aca5236b3ab14a650a949/coinpayu.com/?r=zaids2641" target="_blank" rel="noreferrer">
                            <img class="d-block w-100" src="./images/coinpayu.com_ads.png" width="100%" alt="coinpayu.com"/>
                        </a>
                    </div>
                </div>
            </div>           
        </>
    )
};

export default LeftSliderPtc;
